import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="bg-[#FFFFFF] py-[80px] md:py-[100px]">
      <div className="container mx-auto max-w-[1200px] px-4">
        <div className="flex flex-col md:flex-row items-center gap-[30px] md:gap-[60px]">
          {/* Left Column: Hexagonal Logo */}
          <div className="w-full md:w-1/2 flex justify-center items-center">
            <div className="relative w-full max-w-[433px] animate-in slide-in-from-left duration-1000 ease-out">
              <img
                src="/images/logo-about.bmp"
                alt="Basupra Exim Logo"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          {/* Right Column: Content */}
          <div className="w-full md:w-1/2 animate-in slide-in-from-right duration-1000 ease-out">
            <div className="flex flex-col gap-6 text-left">
              {/* Highlight Paragraph */}
              <h5 className="font-display text-[18px] md:text-[20px] leading-[1.4] font-bold text-[#001d3d]">
                M/s. BasupraEXIM International is a company that focuses mainly on specially designed and developed turnkey projects in the fields of food processing, agro-processing, and engineering.
              </h5>

              {/* Main Description */}
              <div className="font-body text-[16px] leading-[1.6] text-[#4a5568] space-y-4">
                <p>
                  As per the requirement of end customers abroad, we do undertake total turn-key projects which involve market survey, design of the project, layout, manufacture, installation, erection, and commissioning with a satisfactory trial on a needful basis. Further, we also provide full backup for technology, managerial, and marketing aspect along with extension programs.
                </p>
                <p>
                  Our company has experience of foreign business, technical and managerial sound knowledge to establish above units in abroad.
                </p>
                <p>
                  In part of manufacturing our company manufactures major equipment and types of machinery, assemble at our factory site, and other ready equipment manufactured on a subcontract basis, as per our design and requirement. We will provide design, drawing, and raw materials as per customer requirements.
                </p>
              </div>

              {/* See More Button */}
              <div className="pt-4">
                <Link
                  to="/about"
                  className="inline-block px-8 py-3 border-[1.5px] border-[#001d3d] text-[#001d3d] font-display text-[14px] font-semibold uppercase tracking-[0.05em] transition-all duration-300 hover:bg-[#001d3d] hover:text-white rounded-[2px]"
                >
                  See More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
